import { ChevronRightIcon, HomeIcon } from '@heroicons/react/outline'

import Link from '@/components/link'

const pages = [
  { name: 'Blog', href: '/blog', current: false },
  { name: 'This Post', href: '/', current: true },
]

const Navigation = () => {
  return (
    <nav className='mx-auto mb-8 flex max-w-7xl' aria-label='Breadcrumb'>
      <ol className='flex items-center space-x-4'>
        <li>
          <div>
            <Link href='/' className='text-gray-400 hover:text-gray-500'>
              <HomeIcon className='h-5 w-5 flex-shrink-0' aria-hidden='true' />
              <span className='sr-only'>Home</span>
            </Link>
          </div>
        </li>
        {pages.map((page) => (
          <li key={page.name}>
            <div className='flex items-center'>
              <ChevronRightIcon className='h-5 w-5 flex-shrink-0 text-gray-400' />
              <Link
                href={page.href}
                className={`${
                  page.current ? 'pointer-events-none' : ''
                } ml-4 text-sm font-medium text-gray-500 hover:text-gray-700`}
              >
                {page.name}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Navigation
